<template lang="html">
  <StandardDialogFullScreen
    v-if="dialog.show"
    header_max_height="100"
    :overflow_auto="true"
    style="z-index: 20"
    >

    <template #header-text>
      Create TAKT.news
    </template>
    <template #header-close>
      <v-btn @click="closeDialog()">Close</v-btn>
    </template>
    <template #content>
      <v-card class="article-content pa-5">
        <h2>Content</h2>
        <StandardTextfield
          class="mt-2"
          color="snow"
          type="text"
          :placeholder="'New ARTICLE.headline'"
          :value="article.headline"
          @changeValue="article.headline = $event"
        />
        <textarea
          v-model="article.text"
          class="article-text"
          placeholder="New ARTICLE.text"
        />
        <v-btn v-if="dialog.type === 'create'" @click="createArticle()">Create</v-btn>
        <v-btn v-if="dialog.type === 'update'" @click="updateArticle()">Update</v-btn>
      </v-card>
    </template>

  </StandardDialogFullScreen>
  <div v-else>
    <v-btn @click="openCreateDialog()">Create New</v-btn>
    <v-data-table
      :headers="headers"
      :items="getNews"
      :sort-by="[]"
      :sort-desc="[false, true]"
      multi-sort
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon
          medium
          class="mr-2"
          @click="openEditArticle(item)"
        >
          create
        </v-icon>
        <v-icon
          v-if="item.status === 'public'"
          medium
          @click="changeStatus(item, 'private')"
        >
          unpublished
        </v-icon>
        <v-icon
          v-if="item.status === 'private'"
          medium
          @click="changeStatus(item, 'public')"
        >
          check_circle
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'TaktNews',
  components: {
    StandardDialogFullScreen,
    StandardTextfield
   },
  beforeRouteEnter (to, from, next) {
    store.dispatch('TaktNews/requestAllNews').then(res => next(res));
  },
  created(){
    if (this.getNews.length === 0) {
      this.dialog.show = true;
    }
  },
  data: function () {
    return {
      dialog: {
        show: false,
        type: 'create'
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Headline', value: 'headline' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      article: {
        headline: '',
        text: ''
      },
      curr_id: 0
    }
  },
  computed: {
    ...mapGetters('TaktNews', [
      'getNews'
    ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('TaktNews', [
      'createTaktNews',
      'updateTaktNews'
    ]),
    changeStatus(item, status){
      this.updateTaktNews({
        id: item.id,
        update: { status: status }
      });
    },
    openEditArticle(article){
      this.article.headline = article.headline;
      this.article.text = article.text.replace(/<br>/g, '\n');
      this.dialog.type = 'update';
      this.dialog.show = true;
      this.curr_id = article.id;
    },
    openCreateDialog(){
      this.dialog.type = 'create';
      this.dialog.show = true;
    },
    closeDialog(){
      this.dialog.show = false;
      this.article = { headline: '', text: '' };
    },
    createArticle(){
      let res = this.article.text.replace(/\n/g, '<br>');
      this.createTaktNews({text: res, headline: this.article.headline});
      let self = this;
      setTimeout(function () {
        self.closeDialog();
      }, 500);
    },
    updateArticle(){
      let res = this.article.text.replace(/\n/g, '<br>');
      this.updateTaktNews({
        id: this.curr_id,
        update: {text: res, headline: this.article.headline}
      });
      let self = this;
      setTimeout(function () {
        self.closeDialog();
      }, 500);
    }
  }
}
</script>

<style lang="css" scoped>
.article-text {
  height: 60vh;
  width: 100%;
  background-color: snow;
  border-radius: 5px;
  padding: 3px;
  color: black;
}
.article-content {
  background-color: rgba(0,0,0, 0.5);
}
</style>
